import { ZfLoadingSpinner } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useClient } from '../../../api';
import { useNeedContentContext } from '../../../contexts/need-content-context';
import { TopicListItem } from './TopicListItem';

export interface IProps {
    showLeadingCheckbox: boolean;
    style?: { maxHeight: string };
}

export const TopicListSidebar: FunctionComponent<IProps> = ({ showLeadingCheckbox, style }) => {
    const { data: client } = useClient();
    const { talkingPoints } = useNeedContentContext();

    return (
        <div style={{ overflowY: 'auto', ...(style ?? {}) }}>
            {!talkingPoints ? (
                <ZfLoadingSpinner />
            ) : (
                talkingPoints
                    .slice()
                    .sort((a, b) => a.order - b.order)
                    .map((question, index) => (
                        <TopicListItem
                            key={question.id}
                            point={question}
                            showLeadingCheckbox={!!client && showLeadingCheckbox}
                            hasBorderBottom={index < talkingPoints.length - 1}
                        />
                    ))
            )}
        </div>
    );
};
